import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/api";
import { GoldButton } from "../components/common";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [credits, setCredits] = useState(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); setCredits(data.credits); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch (e) {}
      if (tries++ < 8) setTimeout(poll, 1800); else setStatus("error");
    };
    poll();
  }, [params]);

  return (
    <div className="db-grain min-h-screen flex items-center justify-center p-6" style={{ background: "#0C0A0A" }}>
      <div className="relative z-10 db-glass rounded-3xl border border-[#D4AF37]/25 p-10 text-center max-w-md db-fade-up">
        {status === "checking" && <div className="text-[#D4AF37] font-serif text-2xl">Confirming your purchase…</div>}
        {status === "paid" && <>
          <CheckCircle2 size={56} className="text-[#6FD79E] mx-auto mb-4" />
          <h2 className="font-serif text-3xl text-[#FBF8F3]">Payment Successful</h2>
          <p className="text-[#D8D2C9] mt-2">{credits} credits were added to your wallet.</p>
          <GoldButton onClick={() => navigate("/wallet")} className="mt-6">Back to Wallet</GoldButton>
        </>}
        {status === "error" && <>
          <XCircle size={56} className="text-[#E58CA0] mx-auto mb-4" />
          <h2 className="font-serif text-3xl text-[#FBF8F3]">Something went wrong</h2>
          <p className="text-[#D8D2C9] mt-2">We couldn't confirm your payment. If you were charged, your credits will appear shortly.</p>
          <GoldButton onClick={() => navigate("/wallet")} className="mt-6">Back to Wallet</GoldButton>
        </>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="db-grain min-h-screen flex items-center justify-center p-6" style={{ background: "#0C0A0A" }}>
      <div className="relative z-10 db-glass rounded-3xl border border-[#D4AF37]/25 p-10 text-center max-w-md">
        <XCircle size={56} className="text-[#9E978E] mx-auto mb-4" />
        <h2 className="font-serif text-3xl text-[#FBF8F3]">Purchase Cancelled</h2>
        <p className="text-[#D8D2C9] mt-2">No charge was made.</p>
        <GoldButton onClick={() => navigate("/wallet")} className="mt-6">Back to Wallet</GoldButton>
      </div>
    </div>
  );
}
